export enum PrivateRoutes {
  CONSULTATION = '/tabs/schedule',
  PSYCHOLOGIST_LIST = '/tabs/psychologist_list',
  PSYCHOLOGIST_LIST_FILTERS = '/tabs/psychologist_list/filters',
  PSYCHOLOGIST_PROFILE = '/psychologist-profile/:id',
  PSYCHOLOGIST_PROFILE_TAB = '/tabs/psychologist-profile/:id',
  BOOKING_SYSTEM = '/booking-system/:id/:consultationID?',
  SUBSCRIPTION = '/subscription/:id',
  SUBSCRIPTION_PAYMENT = '/subscription/payment/:id/:monthCount/:selectedPlan',
  SUBSCRIPTION_BOOKING = '/subscription/booking/:id/:subscriptionID',
  UPDATE_CONTRACT_WARNING = '/update-contract',
  SUCCESS_TRIAL_SESSIONS = '/success-trial-sessions',
  PAYMENT = '/payment/:id/:date?/:time?',
  VIDEO_CHAT = '/video-call/:psychologistID/:consultationID',
  VIDEO_CHAT_STREAM = '/video-call-s/:psychologistID/:consultationID',
  VIDEO_CHAT_JITSI = '/video-call-j/:psychologistID/:consultationID',
  PROFILE_SETTINGS = '/profile-settings',
  PROFILE_SETTINGS_TAB = '/tabs/profile-settings',
  PROFILE_INFO = '/profile',
  PROFILE_NAME = '/profile-name',
  PROFILE_LAST_NAME = '/profile-last-name',
  PROFILE_DOB = '/profile-dob',
  PROFILE_COUNTRY_OF_LIVING = '/profile-country-of-living',
  NEED_UPDATE_PERSONAL_DATA = '/need-update-personal-data',
  NEED_UPDATE_PERSONAL_DATA_FIRST_NAME = '/need-update-personal-data/first-name',
  NEED_UPDATE_PERSONAL_DATA_LAST_NAME = '/need-update-personal-data/last-name',
  NEED_UPDATE_PERSONAL_DATA_DOB = '/need-update-personal-data/dob',
  NEED_UPDATE_PERSONAL_DATA_COUNTRY_OF_LIVING = '/need-update-personal-data/country-of-living',
  NEED_UPDATE_PERSONAL_DATA_SUCCESS = '/need-update-personal-data/success',
  PROFILE_TAX_ID = '/profile-tax-id',
  PROFILE_EMAIL = '/profile-email',
  PROFILE_PASSWORD = '/profile-password',
  PROFILE_CARDS = '/cards',
  CHATS = '/tabs/chats',
  CHAT_ROOM = '/chat-room/:id',
  SUBSCRIPTION_CONTROL = '/settings/subscription-control',
  RESCHEDULE_CONFIRM = '/reschedule-confirm/:sessionID/:time',
  CANCEL_SESSION_CONFIRM = '/cancel-session-confirm/:sessionID',
  FAVOURITE_SPECIALISTS = '/specialists/favourite',
  FAVOURITE_SPECIALISTS_TAB = '/tabs/specialists/favourite',
  SPECIALIST_REVIEWS = '/specialist/reviews/:id',
  DISCOUNTS = '/discounts',
  SESSION_DETAIL = '/tabs/sessions/:id',
  SESSION_PAYMENTS = '/tabs/sessions/:id/payments',
  STREAM_CHAT_CONVERSATION_LIST = '/chat/list',
}

export enum PublicRoutes {
  AUTH = '/auth',
  PASSWORD = '/auth/password',
  FORGOT_PASSWORD = '/auth/forgot',
  FORGOT_PASSWORD_SUCCESS = '/auth/forgot-success',
  EMAIL_SIGN_IN = '/auth/email-sign-in',
  NAME_SIGN_UP = '/auth/name-sign-up',
  LAST_NAME_SIGN_UP = '/auth/last-name-sign-up',
  DOB_SIGN_UP = '/auth/dob',
  COUNTRY_SIGN_UP = '/auth/country',
  ON_BOARDING = '/on-boarding/:boardId',
  ON_BOARDING_FLOW = '/flow/:flowId',
  ON_BOARDING_FLOW_SCREEN = `/flow/:flowId/:screenId`,
  ON_BOARDING_FLOW_REDIRECT = `/flow/:flowId/r/redirect`, // without "r/redirect" flow doesn't work
  ON_BOARDING_QUESTION = `/on-boarding/:boardId/question/:id`,
  ON_BOARDING_INFO = `/on-boarding/:boardId/info/:id`,
  ON_BOARDING_RESULT = `/on-boarding/:boardId/result/:id`,
  ON_BOARDING_RESULT_INFO = `/on-boarding/:boardId/result-info/:id`,
  ON_BOARDING_REVIEWS = `/on-boarding/:boardId/reviews/:id`,
  ON_BOARDING_SPECIALIST = `/on-boarding/:boardId/specialists/:id`,
  ON_BOARDING_REDIRECT = `/on-boarding/:boardId/redirect`,
  PAYMENT_SUCCESS = '/success/payment/:specialistID',
  SIGN_IN_BY_LINK_SUCCESS = '/sign-in-by-link-success',
  SPECIALIST_BY_SLUG = '/s/:slug',
}
